<fm-header-ui
    [userDropdownList]="userDropdownList$ | async"
    [accountInfo]="accountInfo$ | async"
    [notifications]="notifications$ | async"
    [isAddContactProcessing]="isAddContactProcessing$ | async"
    [messages]="messages$ | async"
    (selectedOptionEvent)="selectedOption($event)"
    (addChosenContactEmitter)="addChosenContact($event)"
    (onLoadMoreNotificationsEmitter)="onLoadMoreNotifications($event)"></fm-header-ui>